import { Action } from 'redux';
import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { RunExtractRefresh } from '../AppActionTypes';

export interface RunExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function runExtractRefresh(tasks: IExtractTaskInfo[]): RunExtractRefreshAction {
  return {
    type: RunExtractRefresh,
    tasks
  };
}
